import React from 'react';

export default function SiteAccessRequired() {
  return (
    <section
      className="section-shell stack gap-md"
      style={{ maxWidth: 600, margin: 'clamp(2rem, 8vh, 5rem) auto' }}
      aria-labelledby="site-access-required-title"
    >
      <div className="stack gap-sm">
        <p className="text-xs fg-muted" style={{ margin: 0, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
          Signed in
        </p>
        <h1 id="site-access-required-title" className="m0">Site access required</h1>
        <p className="fg-muted" style={{ margin: 0 }}>
          No active ITA sites are assigned to your account. You cannot view or change application data until an administrator assigns at least one site.
        </p>
      </div>
      <p className="text-sm fg-muted" style={{ margin: 0 }}>
        Site assignments refresh automatically. If you believe you should already have access, contact an administrator.
      </p>
    </section>
  );
}

